import { Box } from "@material-ui/core";
import { styled } from "@mui/material";
import React from "react";

import { MemoizedReferralBookingForm } from "./bookingForm";

const CustomReferral = styled(Box)(({ theme }) => ({
  padding: "64px 0px 64px 64px",

  ".title": {
    fontSize: "32px",
  },
  [theme.breakpoints.down("md")]: {
    padding: "0px 0px 0px 0px",
  },
  ".title": {
    fontSize: "20px",
  },
}));

const ReferralMain = () => {
  return (
    <CustomReferral>
      {/* <Helmet>
        <title>Refer Turno to your friend</title>
        <meta
          name="description"
          content="Refer electric vehicles from Turno to your friend and earn cashback. Get great offers on EVs or electric auto in India with Turno."
        />
      </Helmet> */}
      <div style={{ marginLeft: "20px" }}>
        {/* <h1 className="title" style={{ color: primary.mainText, }}>Refer and get <strong style={{color:primary.main}}>Free EMI</strong></h1>
        <h2 style={{ display: "none" }}>Refer your friends to earn big</h2> */}
      </div>
      <MemoizedReferralBookingForm />
    </CustomReferral>
  );
};
// export default ReferralMain;
export const MemoizedReferralMain = React.memo(ReferralMain);
